import React from 'react';

import { T8y } from 'ui';

export const Meta6 = () => {
  return (
    <div>
      <T8y as="h1" center bold mb2>
        6 Yard Skip
      </T8y>
      <T8y as="h2" center mb2>
        The Builder’s Skip of Choice
      </T8y>
      <T8y as="p" center mb3>
        6-yard skip, commonly known as the builder's skip, is ideal for
        medium-sized projects involving heavier waste materials. It strikes the
        perfect balance between capacity and convenience, making it a popular
        choice among professionals and DIY enthusiasts alike.
      </T8y>
      <T8y as="h3" center mb2>
        Common Applications for a 6 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Home renovation projects <br />
        Bathroom and kitchen refits <br />
        Landscaping and garden overhauls <br />
        Disposing of bulky items and furniture <br />
      </T8y>
      <T8y as="h3" center mb2>
        Advantages of a 6 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Versatile Use: Suitable for various waste types, including construction
        debris. <br />
        Optimal Size: Provides substantial space without requiring excessive
        room. <br />
        Efficient Waste Management: Keeps your site organized and safe. <br />
        Cost-Effective: Reduces the need for multiple smaller skips. <br />
      </T8y>
      <T8y as="h4" center mb2>
        Steps to Hire a 6 Yard Skip
      </T8y>
      <T8y as="p" center mb5>
        Simply reach out via phone or book online to arrange delivery. If the
        skip needs to be placed on public property, we'll assist with the
        necessary permit applications to ensure compliance with local
        regulations.
      </T8y>
    </div>
  );
};
